export default __webpack_public_path__ + "static/media/print_estimate_shanai_2.14067fbc.svg";